/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiScreeningSubtype } from './ApiScreeningSubtype';
import {
    ApiScreeningSubtypeFromJSON,
    ApiScreeningSubtypeFromJSONTyped,
    ApiScreeningSubtypeToJSON,
    ApiScreeningSubtypeToJSONTyped,
} from './ApiScreeningSubtype';
import type { ApiSanctionType } from './ApiSanctionType';
import {
    ApiSanctionTypeFromJSON,
    ApiSanctionTypeFromJSONTyped,
    ApiSanctionTypeToJSON,
    ApiSanctionTypeToJSONTyped,
} from './ApiSanctionType';

/**
 * 
 * @export
 * @interface ApiScreeningTestScreenableField
 */
export interface ApiScreeningTestScreenableField {
    /**
     * 
     * @type {string}
     * @memberof ApiScreeningTestScreenableField
     */
    screenableField: string;
    /**
     * 
     * @type {ApiSanctionType}
     * @memberof ApiScreeningTestScreenableField
     */
    screeningType: ApiSanctionType;
    /**
     * 
     * @type {ApiScreeningSubtype}
     * @memberof ApiScreeningTestScreenableField
     */
    screeningSubtype: ApiScreeningSubtype;
    /**
     * 
     * @type {string}
     * @memberof ApiScreeningTestScreenableField
     */
    screeningListId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiScreeningTestScreenableField
     */
    screenablePathId?: string;
    /**
     * 
     * @type {number}
     * @memberof ApiScreeningTestScreenableField
     */
    scoreThreshold?: number;
    /**
     * 
     * @type {number}
     * @memberof ApiScreeningTestScreenableField
     */
    prefixMatchLimit?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiScreeningTestScreenableField
     */
    goodlistKey1?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiScreeningTestScreenableField
     */
    goodlistKey2?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiScreeningTestScreenableField
     */
    goodlistKey3?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ApiScreeningTestScreenableField
     */
    includedSegments?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ApiScreeningTestScreenableField
     */
    excludedSegments?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ApiScreeningTestScreenableField
     */
    selectorGroupCodes?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ApiScreeningTestScreenableField
     */
    screeningFlowId?: string;
}



/**
 * Check if a given object implements the ApiScreeningTestScreenableField interface.
 */
export function instanceOfApiScreeningTestScreenableField(value: object): value is ApiScreeningTestScreenableField {
    if (!('screenableField' in value) || value['screenableField'] === undefined) return false;
    if (!('screeningType' in value) || value['screeningType'] === undefined) return false;
    if (!('screeningSubtype' in value) || value['screeningSubtype'] === undefined) return false;
    return true;
}

export function ApiScreeningTestScreenableFieldFromJSON(json: any): ApiScreeningTestScreenableField {
    return ApiScreeningTestScreenableFieldFromJSONTyped(json, false);
}

export function ApiScreeningTestScreenableFieldFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiScreeningTestScreenableField {
    if (json == null) {
        return json;
    }
    return {
        
        'screenableField': json['screenableField'],
        'screeningType': ApiSanctionTypeFromJSON(json['screeningType']),
        'screeningSubtype': ApiScreeningSubtypeFromJSON(json['screeningSubtype']),
        'screeningListId': json['screeningListId'] == null ? undefined : json['screeningListId'],
        'screenablePathId': json['screenablePathId'] == null ? undefined : json['screenablePathId'],
        'scoreThreshold': json['scoreThreshold'] == null ? undefined : json['scoreThreshold'],
        'prefixMatchLimit': json['prefixMatchLimit'] == null ? undefined : json['prefixMatchLimit'],
        'goodlistKey1': json['goodlistKey1'] == null ? undefined : json['goodlistKey1'],
        'goodlistKey2': json['goodlistKey2'] == null ? undefined : json['goodlistKey2'],
        'goodlistKey3': json['goodlistKey3'] == null ? undefined : json['goodlistKey3'],
        'includedSegments': json['includedSegments'] == null ? undefined : json['includedSegments'],
        'excludedSegments': json['excludedSegments'] == null ? undefined : json['excludedSegments'],
        'selectorGroupCodes': json['selectorGroupCodes'] == null ? undefined : json['selectorGroupCodes'],
        'screeningFlowId': json['screeningFlowId'] == null ? undefined : json['screeningFlowId'],
    };
}

export function ApiScreeningTestScreenableFieldToJSON(json: any): ApiScreeningTestScreenableField {
    return ApiScreeningTestScreenableFieldToJSONTyped(json, false);
}

export function ApiScreeningTestScreenableFieldToJSONTyped(value?: ApiScreeningTestScreenableField | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'screenableField': value['screenableField'],
        'screeningType': ApiSanctionTypeToJSON(value['screeningType']),
        'screeningSubtype': ApiScreeningSubtypeToJSON(value['screeningSubtype']),
        'screeningListId': value['screeningListId'],
        'screenablePathId': value['screenablePathId'],
        'scoreThreshold': value['scoreThreshold'],
        'prefixMatchLimit': value['prefixMatchLimit'],
        'goodlistKey1': value['goodlistKey1'],
        'goodlistKey2': value['goodlistKey2'],
        'goodlistKey3': value['goodlistKey3'],
        'includedSegments': value['includedSegments'],
        'excludedSegments': value['excludedSegments'],
        'selectorGroupCodes': value['selectorGroupCodes'],
        'screeningFlowId': value['screeningFlowId'],
    };
}

